import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { faBeer, faPeopleGroup, faFootball } from '@fortawesome/free-solid-svg-icons';
import ViewInMap from './ViewInMap';
import './VenueInformation.scoped.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '../../button/Button';

const VenueInformation = ({ showModal, setShowModal, currentVenue }) => {
    
    const getIconForVenue = (venueType) => {
        switch (venueType) {
            case "sports":
                return faBeer;
            case "team":
                return faPeopleGroup;
            case "stadium":
                return faFootball;
            default:
                return null;
        }
    }

    const [showMapsModal, setShowMapsModal] = useState(false);

    const isIOS = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    const generateGoogleMapsUrl = () => {
        if (!currentVenue) return '#';

        const { addressLineOne = '', city = '', zipCode = '' } = currentVenue || {};
        return `https://www.google.com/maps/search/?api=1&query=${addressLineOne}+${city}+${zipCode}`;
    }

    const generateAppleMapsUrl = () => {
        if (!currentVenue) return '#';

        const { addressLineOne = '', city = '', zipCode = '' } = currentVenue || {};
        return `http://maps.apple.com/?address=${addressLineOne},${city},${zipCode}`;
    }

    const handleViewInMap = () => {
        if (isIOS()) {
            setShowMapsModal(true); // If iOS, show modal with options
        } else {
            // If not iOS, directly open Google Maps
            window.open(generateGoogleMapsUrl(), '_blank');
        }
    }

    return (
        <>
            <Modal className='venue-information' size="sm" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <FontAwesomeIcon className='icon' icon={getIconForVenue(currentVenue?.venueType)}></FontAwesomeIcon>
                    <h3>{currentVenue?.venue}</h3>
                </Modal.Header>
                <Modal.Body>
                    <address className='address'>
                        {currentVenue?.addressLineOne},<br />
                        {currentVenue?.city},<br />
                        {currentVenue?.state},<br />
                        {currentVenue?.zipCode},<br />
                    </address>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        buttonType="Primary"
                        buttonStyle="Standard"
                        buttonText="View in Map"
                        onClick={handleViewInMap}
                    />
                </Modal.Footer>
            </Modal>
            <ViewInMap
                showMapsModal={showMapsModal}
                setShowMapsModal={setShowMapsModal}
                generateGoogleMapsUrl={generateGoogleMapsUrl}
                generateAppleMapsUrl={generateAppleMapsUrl}
            />
        </>
    )
}

export default VenueInformation;